import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import Spinner from 'components/Spinner'
import {
	useChat,
	RoomChatWindow,
	RoomMessageListContainer,
	ChatInputContainer,
} from 'features/Chat'

/**
 * Project room chat.
 *
 * The thread pointer is the project id, which is also the socket room, the
 * Mongo `roomId` and the message cache key — the same arrangement PortfolioChat
 * uses.
 *
 * It used to set `~ProjectName` here as a change-trigger and let ChatContext
 * normalise the pointer after fetching. That worked only when the project was
 * already in the store: on a cold load of /projects/:id/chat the project
 * arrived late, so this effect ran AFTER the fetch had normalised the pointer
 * and overwrote it with the trigger string, leaving `currentMessages` reading a
 * key nothing was stored under. The tab came up empty until you navigated away
 * and back.
 */
const ProjectChatScreen = () => {
	const { id } = useParams()
	const {
		actions: { setCurrentEventId },
	} = useChat()

	const { project, loading } = useSelector(state => ({
		loading: state.projects.isLoading,
		project: state.projects.entities[id],
	}))

	useEffect(() => {
		if (id) setCurrentEventId(id)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [id])

	if (loading) return <Spinner containerHeight="50vh" />
	if (!project?.projectName) return null

	return (
		<RoomChatWindow>
			{/* shouldAlwaysDisplay is required: without it an empty room renders no
			    composer and could never receive its first message. */}
			<RoomMessageListContainer />
			<ChatInputContainer shouldAlwaysDisplay={true} />
		</RoomChatWindow>
	)
}

export default ProjectChatScreen
